import { Pipe, PipeTransform } from '@angular/core';
import { ActivityTypologyStyle } from '@tekman/onmat/constants';

@Pipe({
  name: 'isTestYourself',
})
export class isTestYourselfPipe implements PipeTransform {
  transform(tipology: string): boolean {
    return tipology === ActivityTypologyStyle.TEST_YOURSELF;
  }
}
